import { IdentifierDTO } from '@zazume/zzm-base';
import { DateVO } from '@zazume/zzm-utils';

interface Base {
  enabled: boolean;
}

export interface Respondio extends Base {
  workspaceId: string;
}

export interface Zendesk extends Base {
  username: string;
  subdomain: string;
  categoryFieldId?: number;
}

export interface Onlygal extends Base {
  username: string;
  password: string;
}

export interface Fiskaly extends Base {
}

export interface Slack extends Base {
}

interface OrganizationIntegrationsSettingsProps {
  _id: IdentifierDTO;
  organizationId: IdentifierDTO;
  respondio?: Respondio;
  zendesk?: Zendesk;
  onlygal?: Onlygal;
  slack?: Slack;
  createdAt: DateVO;
  fiskaly?: Fiskaly;
}

export class OrganizationIntegrationsSettings {
  _id: IdentifierDTO;
  organizationId: IdentifierDTO;
  respondio?: Respondio;
  zendesk?: Zendesk;
  onlygal?: Onlygal;
  slack?: Slack;
  fiskaly?: Fiskaly;
  createdAt: DateVO;

  constructor(params: OrganizationIntegrationsSettingsProps) {
    this._id = params._id;
    this.organizationId = params.organizationId;
    this.respondio = params.respondio;
    this.zendesk = params.zendesk;
    this.onlygal = params.onlygal;
    this.slack = params.slack;
    this.createdAt = params.createdAt;
    this.fiskaly = params.fiskaly;
  }

  isRespondioEnabled(): boolean {
    return Boolean(this.respondio?.enabled);
  }

  isRespondioIntegrated(): boolean {
    return Boolean(this.respondio);
  }

  isZendeskEnabled(): boolean {
    return Boolean(this.zendesk?.enabled);
  }

  isOnlygalEnabled(): boolean {
    return Boolean(this.onlygal?.enabled);
  }

  isOnlygalIntegrated(): boolean {
    return Boolean(this.onlygal);
  }

  isZendeskIntegrated(): boolean {
    return Boolean(this.zendesk);
  }

  isSlackEnabled(): boolean {
    return Boolean(this.slack?.enabled);
  }

  isSlackIntegrated(): boolean {
    return Boolean(this.slack);
  }

  isFiskalyIntegrated(): boolean {
    return Boolean(this.fiskaly);
  }

  isFiskalyEnabled(): boolean {
    return Boolean(this.fiskaly?.enabled);
  }

  hasOtherIntegrationToCreate(): boolean {
    return !this.isRespondioIntegrated()
      || !this.isZendeskIntegrated()
      || !this.isOnlygalIntegrated()
      || !this.isSlackIntegrated()
      || !this.isFiskalyIntegrated();
  }

}
